<template>
  <div class="crush-page">
    <div class="crush-shell">
      <header class="crush-head">
        <button type="button" class="head-btn" :aria-label="$t('auth.back')" @click="back">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
        </button>

        <div class="head-copy">
          <h1>{{ copy.title }}</h1>
          <p>{{ copy.subtitle }}</p>
        </div>

        <button type="button" class="head-btn" :aria-label="$t('auth.home')" @click="goHome">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 11l9-8 9 8"></path>
            <path d="M5 10v10h14V10"></path>
          </svg>
        </button>
      </header>

      <main class="crush-content">
        <div class="summary-card">
          {{ copy.summaryPrefix }}
          <b>{{ favorites.length }}</b>
          {{ copy.summarySuffix }}
        </div>

        <div v-if="favorites.length" class="favorite-grid">
          <button
            v-for="item in favorites"
            :key="`fav-${item.favorite_id}`"
            type="button"
            class="favorite-card"
            @click="openProfile(item)"
          >
            <div class="favorite-cover">
              <img :src="item.image || fallbackImage" :alt="item.name || copy.title" />
            </div>
            <div class="favorite-copy">
              <strong>{{ item.name || copy.defaultName }}</strong>
              <span>{{ formatMeta(item) }}</span>
            </div>
          </button>
        </div>

        <div v-else class="empty-state">
          <div class="empty-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
              <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1 7.8 7.8 7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"></path>
            </svg>
          </div>
          <strong>{{ copy.emptyTitle }}</strong>
          <p>{{ copy.emptyDesc }}</p>
          <button type="button" class="discover-btn" @click="goHome">
            {{ copy.discoverText }}
          </button>
        </div>
      </main>
    </div>

    <Footer :is_show="true" />
  </div>
</template>

<script>
import Footer from "@/common/Footer.vue";
import { getPageCopy } from "@/common/pageLocale";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      favorites: [],
      fallbackImage: "/img/null.png",
    };
  },
  computed: {
    copy() {
      return getPageCopy(this, "crushList");
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$toast(this.copy.loginFirst);
      this.$router.replace("/Login");
      return;
    }
    this.fetchFavorites();
  },
  mounted() {
    document.title = `${this.copy.title} · OMN`;
  },
  methods: {
    async fetchFavorites() {
      const res = await this.$http({
        method: "get",
        url: "xuanfei_favorite_list",
      });
      if (res && res.code === 200) {
        this.favorites = Array.isArray(res.data) ? res.data : [];
        return;
      }
      this.favorites = [];
      if (res && res.msg) {
        this.$toast(res.msg);
      }
    },
    formatMeta(item) {
      const pieces = [item.city, item.role].filter((value) => value);
      return pieces.length ? pieces.join(" · ") : this.copy.defaultMeta;
    },
    openProfile(item) {
      this.$router.push({
        path: "/Profile",
        query: {
          id: item.id,
          name: item.name,
          role: item.role,
          city: item.city,
          publicId: item.public_id,
          image: item.image,
          about: item.about,
        },
      });
    },
    back() {
      window.history.back();
    },
    goHome() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style lang="less" scoped>
.crush-page {
  min-height: 100vh;
  min-height: 100dvh;
  background:
    radial-gradient(circle at 100% 0, rgba(255, 63, 120, 0.11), transparent 28%),
    radial-gradient(circle at 0 14%, rgba(165, 92, 255, 0.1), transparent 26%),
    #0a0710;
  color: #fff7fb;
}

.crush-shell {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  max-width: none;
  margin: 0;
  padding-bottom: 7rem;
}

.crush-head {
  position: sticky;
  top: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: 2.625rem 1fr 2.625rem;
  align-items: center;
  min-height: 4.1875rem;
  padding: max(0.5rem, env(safe-area-inset-top)) 0.8125rem 0.5rem;
  background: rgba(10, 7, 16, 0.92);
  border-bottom: 1px solid rgba(255, 255, 255, 0.085);
  backdrop-filter: blur(1.125rem);
  -webkit-backdrop-filter: blur(1.125rem);
}

.head-btn {
  width: 2.375rem;
  height: 2.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.085);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.045);
  color: #fff;
}

.head-btn svg {
  width: 1.1875rem;
  height: 1.1875rem;
}

.head-copy h1 {
  margin: 0;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 900;
}

.head-copy p {
  margin: 0.1875rem 0 0;
  text-align: center;
  color: #a89baa;
  font-size: 0.5625rem;
  line-height: 1.4;
}

.crush-content {
  padding: 1rem;
}

.summary-card {
  min-height: 2.5rem;
  padding: 0.8125rem 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(255, 98, 146, 0.28);
  background: rgba(255, 63, 120, 0.08);
  color: #f6e5ee;
  font-size: 0.8125rem;
  font-weight: 700;
}

.summary-card b {
  color: #ff6e9b;
  font-size: 1rem;
}

.favorite-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.875rem;
  margin-top: 0.875rem;
}

.favorite-card {
  border: 1px solid rgba(255, 255, 255, 0.085);
  border-radius: 1.2rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  text-align: left;
  box-shadow: 0 0.8125rem 2.125rem rgba(0, 0, 0, 0.18);
}

.favorite-cover {
  aspect-ratio: 0.78;
  background: rgba(255, 255, 255, 0.05);
}

.favorite-cover img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.favorite-copy {
  padding: 0.75rem 0.75rem 0.875rem;
}

.favorite-copy strong {
  display: block;
  font-size: 0.9375rem;
  font-weight: 900;
  line-height: 1.3;
}

.favorite-copy span {
  display: block;
  margin-top: 0.3125rem;
  color: #a89baa;
  font-size: 0.75rem;
  line-height: 1.4;
}

.empty-state {
  display: flex;
  min-height: calc(100vh - 15rem);
  min-height: calc(100dvh - 15rem);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.empty-icon {
  width: 4.25rem;
  height: 4.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 98, 146, 0.28);
  background: rgba(255, 63, 120, 0.06);
  color: #ff6e9b;
  box-shadow: 0 0.75rem 1.75rem rgba(255, 63, 120, 0.12);
}

.empty-icon svg {
  width: 1.75rem;
  height: 1.75rem;
}

.empty-state strong {
  margin-top: 1rem;
  font-size: 1.0625rem;
  font-weight: 900;
}

.empty-state p {
  max-width: 15rem;
  margin: 0.5rem 0 0;
  color: #b8aab7;
  font-size: 0.75rem;
  line-height: 1.6;
}

.discover-btn {
  min-width: 7.5rem;
  height: 2.625rem;
  margin-top: 1rem;
  padding: 0 1.25rem;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #ff6d9c, #ff3f78);
  box-shadow: 0 0.6875rem 1.625rem rgba(255, 63, 120, 0.24);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 900;
}

button {
  cursor: pointer;
}

@media (min-width: 48rem) {
  .crush-shell {
    max-width: 25rem;
    margin: 0 auto;
  }
}
</style>
